import { get } from 'lodash';
import React, { useEffect } from 'react';
import { Input, ModalFooter, OriSelect, TextArea } from 'src/components/Antd';
import FocusPoint from 'src/components/ImageFocusPointEdit';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import {
  Field,
  FieldFormItem,
  Form,
  antdErrorDisplayAdaptor,
  itemWrapperErrorDisplayAdaptor,
} from 'src/components/RcForm';
import Uploader from 'src/constrains/SingleImageUploader';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import {
  contentImage,
  contentPage,
  imageSetting,
  subtitle,
  summary,
  salesChannelUuid,
} from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
const ContentPage = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    disabled,
    //contentPageList,
    index,
    //selectedPages,
    onCancel,
    onConfirm,
    data,
    validators,
    isNew,
    scContentPages,
  } = props;
  const salesChannels = Object.values(scContentPages || {})
    .filter((i) => i)
    .map((i) => {
      const salesChannel = get(i, 'salesChannel');
      const uuid = get(salesChannel, 'uuid');
      const name = get(salesChannel, 'name');
      return {
        label: name,
        value: uuid,
      };
    });

  const {
    contentPage: cV,
    image: iV,
    subtitle: subV,
    summary: sumV,
  } = validators || {};

  const [editForm] = Form.useForm();

  useEffect(() => {
    const d = { ...data };
    if (!d.salesChannelUuid) {
      const firstSalesChannel = get(Object.keys(scContentPages), '0');
      d.salesChannelUuid = firstSalesChannel;
    }
    editForm.setFieldsValue(d);
  }, []);

  // const { inUsePages = [] } = contentPageList || {};

  // const options = //selectedPages ||
  //   (inUsePages || []).map((i) => {
  //     const { uuid, name } = i;
  //     return {
  //       label: name,
  //       value: uuid,
  //     };
  //   });

  const handleOnConfirm = () => {
    editForm.validateFields().then((d) => {
      onConfirm({ ...(data || {}), ...d, isNew });
    });
  };

  return (
    <Section {...sectionProps}>
      <Form form={editForm}>
        <ItemWrapper title={`Sales Channels*`}>
          <Field name={salesChannelUuid}>
            {(props, meta) => {
              const { value, onChange } = props;
              const { error, help } = antdErrorDisplayAdaptor(meta);
              return (
                <FieldFormItem error={error} help={help}>
                  <OriSelect
                    placeholder={getI18n('general.selectContentPage')}
                    disabled={disabled}
                    options={salesChannels}
                    value={value}
                    filterOption={(input, option) => {
                      return (option.label || '')
                        .toLowerCase()
                        .includes(input?.toLowerCase());
                    }} //contentPageInvalid
                    showSearch
                    optionFilterProp='label'
                    onChange={(v) => {
                      onChange(v);
                      editForm.setFieldsValue({ [contentPage]: null });
                    }}
                    size='large'
                  />
                </FieldFormItem>
              );
            }}
          </Field>
        </ItemWrapper>

        <ItemWrapper
          title={`${getI18n('general.sider.contentPage')} ${index + 1}*`}>
          <Field
            name={contentPage}
            shouldUpdate
            rules={[
              {
                // validateTrigger: 'onSubmit',
                validator: async (rules: any, value: any) => {
                  if (cV) {
                    const res = cV(
                      value, //selectedPages ||
                      // inUsePages || [],
                    );
                    const hasError = get(res, 'hasError');
                    const errors = get(res, 'errors');
                    if (hasError) {
                      return Promise.reject(
                        new Error((errors || []).join(',')),
                      );
                      //</ItemWrapper>throw Error((errors || []).join(','));
                    }
                  }
                },
              },
            ]}>
            {(props, meta, { getFieldValue }) => {
              const selectedSalesChannelUuid = getFieldValue(salesChannelUuid);
              const { value, onChange } = props;
              const contentPageOptions =
                get(
                  scContentPages,
                  `${selectedSalesChannelUuid}.contentPages`,
                ) || [];

              const contentUuid = get(value, 'uuid');
              const handleOnContentPageChange = (contentPageUuid) => {
                // const { inUsePages, pendingPages, previousPages } =
                //   contentPageList || {};
                const list =
                  //selectedPages ||
                  contentPageOptions;

                const t = list.find((i) => i.uuid === contentPageUuid);
                const contentSummary = get(t, summary) || '';
                const contentSummary120 = contentSummary.slice(0, 120);
                onChange(t);
                editForm.setFieldsValue({ [summary]: contentSummary120 });
              };

              //      error && {
              //   status: EnumFormItemStatus.error,
              //   help: help || 'Please fill the form',
              // })}
              const { error, help } = antdErrorDisplayAdaptor(meta);

              return (
                <FieldFormItem error={error} help={help}>
                  <OriSelect
                    placeholder={getI18n('general.selectContentPage')}
                    disabled={disabled}
                    options={contentPageOptions.map((i) => {
                      const { uuid, name } = i;
                      return {
                        label: name,
                        value: uuid,
                      };
                    })}
                    value={contentUuid}
                    filterOption={(input, option) => {
                      return (option.label || '')
                        .toLowerCase()
                        .includes(input?.toLowerCase());
                    }} //contentPageInvalid
                    showSearch
                    optionFilterProp='label'
                    onChange={handleOnContentPageChange}
                    size='large'
                  />
                </FieldFormItem>
              );
            }}
          </Field>
        </ItemWrapper>
        <Field
          name={contentImage}
          rules={[
            {
              validator: async (rules: any, value: any) => {
                if (cV) {
                  const res = iV(value);
                  const hasError = get(res, 'hasError');
                  const errors = get(res, 'errors');
                  if (hasError) {
                    return Promise.reject(new Error((errors || []).join(',')));
                    //</ItemWrapper>throw Error((errors || []).join(','));
                  }
                }
              },
            },
          ]}>
          {(props, m) => {
            const e = itemWrapperErrorDisplayAdaptor(m);

            return (
              <ItemWrapper
                title={`${getI18n('general.tools_helper.image')}/${getI18n(
                  'general.tools_helper.video',
                )}*`}
                bottomTitle={`${getI18n(
                  'general.allowedfiletypes',
                )}: jpeg, gif, png, mov, mp4`}
                size='small'
                {...e}>
                <Uploader height={180} {...props} />
              </ItemWrapper>
            );
          }}
        </Field>
        <Field
          shouldUpdate={(p, c) => {
            return get(p, `${contentImage}`) !== get(c, `${contentImage}`);
          }}>
          {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
            const image = getFieldValue(contentImage);
            return (
              <Field name={[contentImage, imageSetting]}>
                {(props, meta) => {
                  //const value = props.value;
                  const onChange = props.onChange;
                  return (
                    <FocusPoint
                      image={image}
                      onChange={(image) => {
                        onChange(get(image, 'image.imageSetting'));
                      }}
                    />
                  );
                }}
              </Field>
            );
          }}
        </Field>
        <ItemWrapper title={`${getI18n('general.subtitle')}*`}>
          <Field
            name={subtitle}
            rules={[
              {
                validator: async (rules: any, value: any) => {
                  if (cV) {
                    const res = subV(value);
                    const hasError = get(res, 'hasError');
                    const errors = get(res, 'errors');
                    if (hasError) {
                      return Promise.reject(
                        new Error((errors || []).join(',')),
                      );
                      //</ItemWrapper>throw Error((errors || []).join(','));
                    }
                  }
                },
              },
            ]}>
            {(props, m) => {
              const eP = antdErrorDisplayAdaptor(m);
              return (
                <Input maxLength={40} size='large' {...props} {...m} {...eP} />
              );
            }}
          </Field>
        </ItemWrapper>
        <ItemWrapper title={`${getI18n('general.summary')}*`}>
          <Field
            name={summary}
            rules={[
              {
                validator: async (rules: any, value: any) => {
                  if (cV) {
                    const res = sumV(value);
                    const hasError = get(res, 'hasError');
                    const errors = get(res, 'errors');
                    if (hasError) {
                      return Promise.reject(
                        new Error((errors || []).join(',')),
                      );
                      //</ItemWrapper>throw Error((errors || []).join(','));
                    }
                  }
                },
              },
            ]}>
            {(props, m) => {
              const eP = antdErrorDisplayAdaptor(m);
              return (
                <TextArea
                  maxLength={120}
                  size='large'
                  {...props}
                  {...m}
                  {...eP}
                />
              );
            }}
          </Field>
        </ItemWrapper>
        <ModalFooter onCancel={onCancel} onOk={handleOnConfirm} />
      </Form>
    </Section>
  );
};
export default ContentPage;
